import { fetchDuties, updateDuties, storeDuties, updateDutyOrders, sortDuties } from '@/service/shift';

function settingDutiesCtrl($scope) {
  const { cloneDeep } = require('lodash');
  $scope.isFullEditMode = false;
  $scope.isShowUnusedMode = false;
  $scope.childcareDuty = null;
  $scope.dutyNames = [];
  $scope.tmpEditClass = {};

  /**
   * 重複バリデーション用の配列を作成
   */
  const createDuplicateDutyNames = (duties) => {
    const dutyNames = duties.map((duty) => duty.dutyName);
    $scope.duties = duties.map((duty) => {
      return {
        ...duty,
        dutyNames: dutyNames.filter((name) => name !== duty.dutyName),
      };
    });
  };

  /**
   * 重複バリデーション用データ
   */
  $scope.dutyDuplicateValidationRule = {
    message: '業務名が重複しています',
    items: [],
    value: '',
  };

  /**
   * 業務設定のinputに入力されたとき
   */
  $scope.onInputDuty = (dutyName) => {
    $scope.dutyDuplicateValidationRule.value = dutyName;
    $scope.$apply();
  };

  /**
   * 保育業務を判定し、html側で保育は編集不可にする
   */
  const getChildcareDuty = () => {
    $scope.childcareDuty = $scope.duties.find((duty) => duty.dutyName === '保育');
  };

  const initial = async () => {
    const fetchedDuties = await fetchDuties();
    createDuplicateDutyNames(fetchedDuties);
    $scope.dutyNames = fetchedDuties.flatMap((duty) => duty.dutyName);
    getChildcareDuty();
    $scope.$digest();
  };
  initial();

  // 複数同時編集できないので編集可能な項目のインデックスを保持
  $scope.editMode = {
    dutyId: '',
  };

  /**
   * コピーデータを作成
   */
  const setClonedDuties = () => {
    $scope.clonedDuties = cloneDeep($scope.duties);
  };

  /**
   * 業務設定を並び替え
   */
  $scope.sortDutyOptions = {
    handle: '[data-js=drag_handle]',
    axis: 'y',
    cursor: 'move',
    stop: () => updateDutyOrders($scope.duties),
    placeholder: 'placeholder',
  };

  /**
   * 業務設定の全体が編集モードか確認
   */
  const turnOnSettingDutiesEditModeEntirety = () => {
    $scope.isFullEditMode = true;
  };

  const turnOffSettingDutiesEditModeEntirety = () => {
    createDuplicateDutyNames($scope.duties);
    $scope.isFullEditMode = false;
  };

  /**
   * 新規作成
   */
  $scope.createDuties = () => {
    setClonedDuties();
    setDutyDuplicateValidationRule({ dutyName: '' });
    // 重複バリデーション用の配列を作成
    const dutyNames = $scope.duties.map((duty) => duty.dutyName);
    const emptyDuty = { dutyId: '', dutyName: '', dutyCategory: 1, disabled: false, dutyNames };
    $scope.tmpEditClass = cloneDeep(emptyDuty);
    $scope.duties.unshift(emptyDuty);
    turnOnSettingDutiesEditModeEntirety();
  };

  /**
   * 新規データの保存
   */
  const saveCreateDuty = async (targetDuty) => {
    const payload = {
      dutyCategory: targetDuty.dutyCategory,
      dutyName: targetDuty.dutyName,
    };
    const createdDuties = await storeDuties(payload);

    $scope.duties = $scope.duties.filter((duty) => duty.dutyId);
    $scope.duties.unshift({
      ...$scope.tmpEditClass,
      dutyCategory: createdDuties.dutyCategory,
      dutyId: createdDuties.dutyId,
      order: createdDuties.order,
      version: createdDuties.version,
    });
  };

  /**
   * 既存データの更新
   */
  const saveEditDuty = async (targetDuty) => {
    const { dutyId } = targetDuty;
    const payload = {
      disabled: targetDuty.disabled,
      dutyCategory: targetDuty.dutyCategory,
      dutyName: targetDuty.dutyName,
      version: targetDuty.version,
    };
    const updatedDuty = await updateDuties(dutyId, payload);

    const targetIdx = $scope.duties.findIndex((duty) => duty.dutyId === updatedDuty.dutyId);
    $scope.duties[targetIdx] = {
      ...targetDuty,
      ...updatedDuty,
      order: targetDuty.order, // APIの戻りが常に0なのでこちらで元の値を入れておく
    };

    sortDuties($scope.duties);
  };

  /**
   * 保存
   */
  $scope.saveSettingDuties = async (targetDuty) => {
    $scope.editMode.dutyId = '';
    targetDuty.dutyId ? await saveEditDuty($scope.tmpEditClass) : await saveCreateDuty($scope.tmpEditClass);
    $scope.dutyNames = $scope.duties.map((duty) => duty.dutyName);

    turnOffSettingDutiesEditModeEntirety();
    $scope.$digest();
  };

  /**
   * キャンセル
   */
  $scope.cancelSettingDuties = () => {
    $scope.editMode.dutyId = '';
    turnOffSettingDutiesEditModeEntirety();
    $scope.duties = $scope.clonedDuties;
    $scope.tmpEditClass = {};
  };

  const setDutyDuplicateValidationRule = (duty) => {
    $scope.dutyDuplicateValidationRule.items = cloneDeep($scope.dutyNames).filter(
      (dutyName) => dutyName !== duty.dutyName
    );
    $scope.dutyDuplicateValidationRule.value = duty.dutyName;
  };

  /**
   * 編集
   */
  $scope.editSettingDuties = (duty) => {
    setClonedDuties();
    $scope.editMode.dutyId = duty.dutyId;
    setDutyDuplicateValidationRule(duty);

    turnOnSettingDutiesEditModeEntirety();
    $scope.tmpEditClass = cloneDeep(duty);
  };
}

angular.module('inspinia').controller('settingDutiesCtrl', settingDutiesCtrl);
